import { useState } from "react";
import CompareProductFooter from "../CompareProductFooter";
import CompanyInformation from "./CompanyInformation";
import UsefulLinks from "./UsefulLinks";
import CompanySocialInformation from "./CompanySocialInformation";
import useSWR from "swr";
import { useRouter } from "next/router";
import { getFooterData } from "@/services/global";
import { getCookie } from "cookies-next";
import BottomFooter from "./BottomFooter";
import LazyLoading from "@/components/LazyLoading";

function Footer({ t }) {
  const [active, setActive] = useState(null);
  const { locale } = useRouter();

  const handshake = getCookie("handshake");

  const changeActiveAccordionHandler = (type) => {
    setActive(type);
  };

  const { data: footerData, isLoading } = useSWR(
    `dynamic-footer/${locale}`,
    () => getFooterData(handshake),
    { revalidateOnFocus: false }
  );
  return (
    <>
      {isLoading ? (
        <div className="text-white bg-black">
          <LazyLoading
            color="white"
            parentClassName={"min-h-[430px] max-[768px]:min-h-[480px]"}
          />
        </div>
      ) : (
        footerData?.data?.length > 0 && (
          <footer className="pt-10 text-sm text-white bg-black">
            <div className="w-11/12 max-[570px]:w-[98%] mx-auto grid grid-cols-8 gap-4">
              <CompanyInformation
                active={active}
                onActiveAccordion={changeActiveAccordionHandler}
                data={footerData?.data?.[0]}
              />
              <UsefulLinks
                active={active}
                onActiveAccordion={changeActiveAccordionHandler}
                t={t}
                data={footerData?.data?.[0]}
              />
              <CompanySocialInformation
                t={t}
                active={active}
                onActiveAccordion={changeActiveAccordionHandler}
                data={footerData?.data?.[0]}
              />
            </div>

            <BottomFooter data={footerData?.data?.[0]} />

            <CompareProductFooter />
          </footer>
        )
      )}
    </>
  );
}

export default Footer;
